import { render, staticRenderFns } from "./selectDomainCard.vue?vue&type=template&id=20a20872&scoped=true"
import script from "./selectDomainCard.vue?vue&type=script&lang=ts"
export * from "./selectDomainCard.vue?vue&type=script&lang=ts"
import style0 from "./selectDomainCard.vue?vue&type=style&index=0&id=20a20872&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a20872",
  null
  
)

export default component.exports